export const truncateAfterManualLinebreak = (text?: string) =>
    text?.includes("\n") ? text.substring(0, text.indexOf("\n")) : text;
